import {useSelector} from 'react-redux';
import AdvertiseContent from './advertiseContent/AdvertiseContent';
// import {useParams} from 'react-router-dom';
import {useEffect} from 'react';
import {uploadFile} from '../../redux/user/userActions';
import {getHidePublishPopup, publishEvent, updateEventSettings} from '../../redux/event/eventActions';
import * as Yup from 'yup';
import FormContext from '../../pages/components/formContext/FormContext';
import {Form} from 'formik';
import useTimeout from '../../hooks/useTimeout';
import {hasAccountAccess, isMaster} from '../../functions/permission';
import {TCreditProps} from '../imagePopup/externalImagePopup/ExternalImagePopup';

export type TImage = {
    image: string;
    imageId: string;
    credit: TCreditProps;
}
interface AdvertiseValues {
    showInLive: boolean;
    tickchakIndex: boolean;
    glatticketIndex: boolean;
    privateEvent: boolean;
    mobileImage: TImage;
    postImage: TImage;
}
function PopupAfterAdvertise({close, showClass} : {close: () => void; showClass: string}) {
    const {settings, eid, lang,  getHidePublishPopupXHR} = useSelector((s:any) => ({ //type,
        settings: s.event.settings,
        eid: s.event.eid,
        lang: s.event.lang,
        type: s.event.type,
        getHidePublishPopupXHR: s.event.getHidePublishPopupXHR
    }));
    // const {page} = useParams();
    const langDesign = settings?.langDesign;
    const {showInLive, tickchakIndex, glatticketIndex} =  settings.event;
    const timer = useTimeout();

    const updateGoogleIndex = (value) => {
        updateEventSettings('isIndexed', value, 'event');
    };

    const updateEventImage = async (data, screenType) => {
        const name = `fbImg${screenType}`;
        data.image = await uploadFile(data.image, '', `ho${name}`, eid);
    };
    const initialValues: AdvertiseValues = {
        showInLive: !!showInLive||false,
        tickchakIndex: !!tickchakIndex||false,
        glatticketIndex: !!glatticketIndex||false,
        privateEvent: false,
        mobileImage: {
            image: settings?.design?.fbImgMobile,
            imageId: settings?.design?.fbImgMobileId,
            credit: settings?.design?.credit?.mobile
        },
        postImage: {
            image: settings?.design?.fbImgPost,
            imageId: settings?.design?.fbImgPostId,
            credit: settings?.design?.credit?.post
        }
    };
    const validationSchema = Yup.object().shape({
        showInLive: Yup.boolean(),
        tickchakIndex: Yup.boolean(),
        glatticketIndex: Yup.boolean(),
        privateEvent: Yup.boolean()
    });
    const onSubmitForm = async (_changedValues: AdvertiseValues, values: AdvertiseValues) => {
        try {
            const imageUpdates = [];
            if(values.mobileImage?.image) {
                imageUpdates.push(updateEventImage(values.mobileImage, 'Mobile'));
            }
            if(values.postImage?.image) {
                imageUpdates.push(updateEventImage(values.postImage, 'Post'));
            }
            await Promise.all(imageUpdates);
            const hasGlatticketAccess = hasAccountAccess('glatticket show') || isMaster();
            const glatticketIndex = values.glatticketIndex ? (!hasGlatticketAccess ? 2 : 1) : 0;

            await publishEvent(eid, {
                showInLive: values.showInLive,
                tickchakIndex: values.tickchakIndex ? 1 : 0,
                glatticketIndex,
                images:{
                    fbImgMobile: values.mobileImage,
                    fbImgPost: values.postImage
                },
                lang: lang,
                langDesign: langDesign
            });

            timer.current = setTimeout(close, 1000) as any;
        } catch (error) {
            console.error('Failed to submit form:', error);
        }
    };
    // useEffect(()=>{
    //     if(page!='design'&& type!=='hub')
    //         close();
    // },[page]);
    useEffect(()=>{
        if(!getHidePublishPopupXHR)
            getHidePublishPopup().then();
    },[]);
    return (
        <FormContext
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmitForm}
            enableReinitialize
        >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <AdvertiseContent
                    updateGoogleIndex={updateGoogleIndex}
                    close={close}
                    showClass={showClass}
                />
            </Form>
        </FormContext>
    );
}

export default PopupAfterAdvertise;
